import { api, ReactQueryOptions, RouterInputs } from '@api';
import { staleTimeIndex } from '@specs/constants';
type optionsType = ReactQueryOptions['ToyManager']['getShopifyToysAmount'];
type inputType = RouterInputs['ToyManager']['getShopifyToysAmount'];
export const useGetShopifyToysAmount = (input: inputType, options?: optionsType) => api.ToyManager.getShopifyToysAmount.useQuery(input, {
  ...options,
  queryKey: ['ToyManager.getShopifyToysAmount', input],
  staleTime: 10 * 60 * 1000 * staleTimeIndex // 10 mins
});